<template>
	<div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" v-bind="$attrs" />
	<svg v-else :class="svgClass" aria-hidden="true" v-bind="$attrs">
		<use :href="iconName" :fill="color" />
	</svg>
</template>

<script>
export default {
	name: "SvgIcon",
	props: {
		iconClass: {
			type: String,
			required: false,
			default: "",
		},
		className: {
			type: String,
			default: "",
		},
		color: {
			type: String,
			default: "#333",
		},
	},
	computed: {
		isExternal() {
			return false;
		},
		iconName() {
			return `#icon-${this.iconClass}`;
		},
		svgClass() {
			if (this.className) {
				return "svg-icon " + this.className;
			} else {
				return "svg-icon";
			}
		},
		styleExternalIcon() {
			return {
				mask: `url(${this.iconClass}) no-repeat 50% 50%`,
				"-webkit-mask": `url(${this.iconClass}) no-repeat 50% 50%`,
			};
		},
	},
};
</script>

<style scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}

.svg-external-icon {
	background-color: currentColor;
	mask-size: cover !important;
	display: inline-block;
}
</style>
